import { userCanSeeCredits } from '@ab-core-functions/user-permission';
import { PermissionWrapper, ROUTES, EXTERNAL_ROUTES, formatNumber } from '@ab-core/functions';
import { useAuth } from '@ab-core/hooks';
import type { FC } from 'react';
import React from 'react';
import { PointElement } from './pointElement';
import { PointsOverviewWrapper } from './styled';
import { Link, LINK_VARIANT } from '@ab-core/link';

type PointsOverviewProps = React.ComponentPropsWithoutRef<'div'>;

export const PointsOverview: FC<PointsOverviewProps> = (props) => {
    const { ...rest } = props;
    const { user } = useAuth(false);

    const canSeeCredits = userCanSeeCredits();

    return (
        <PointsOverviewWrapper {...rest}>
            {canSeeCredits && (
                <Link to={ROUTES.CREDIT_INFO} variant={LINK_VARIANT.LINK_ONLY}>
                    <PointElement iconName="Credits">{formatNumber(user?.availableCredits)}</PointElement>
                </Link>
            )}

            <PermissionWrapper permission="canSeeTecselect">
                <Link to={EXTERNAL_ROUTES.TECSELECT_INFO} target="_blank" variant={LINK_VARIANT.LINK_ONLY}>
                    <PointElement iconName="Tecselect">{formatNumber(user?.tecselectPoints)}</PointElement>
                </Link>
            </PermissionWrapper>
        </PointsOverviewWrapper>
    );
};
